export default __webpack_public_path__ + "static/media/twitter.e9aac3bb.svg";